import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { BehaviorSubject, of } from 'rxjs';
import { Status } from 'src/app/components/company/models/new/status';
import { Selectable } from 'src/app/shared/types/selectable.type';

@Injectable({
	providedIn: 'root'
})
export class OrderStatusFilterService extends IFilterListService<Status> {
	private originalDatasource: Selectable<Status>[] = [
		{
			id: 1,
			name: 'Missing images',
			displayId: 1,
			displayName: 'Missing images',
			disabled: false,
			selected: false
		},
		{
			id: 2,
			name: 'Shooting',
			displayId: 2,
			displayName: 'Shooting',
			disabled: false,
			selected: false
		},
		{
			id: 3,
			name: 'Confirmed',
			displayId: 3,
			displayName: 'Confirmed',
			disabled: false,
			selected: false
		}
	];

	datasource = new BehaviorSubject<Selectable<Status>[]>([...this.originalDatasource]);

	search(searchText: string, variables: any): void {
		if (!searchText?.trim()) {
			this.datasource.next([...this.originalDatasource]);
			return;
		}

		const filtered = this.originalDatasource.filter((status) => status.name?.toLowerCase().includes(searchText.toLowerCase()));

		this.datasource.next(filtered);
	}

	searchById(_id: string[] | string) {
		const ids = Array.isArray(_id) ? _id.map((id) => Number(id)) : [Number(_id)];

		const result = this.originalDatasource.filter((status) => ids.includes(status.id!));

		return of(result);
	}
}